import angular from 'angular';
import textareaEditor from '../../RichTextEditor/EditorTextarea/EditorTextarea';

/**
 * @memberOf cms.input.htmlEditor
 * @property {object}   bindings.errors   Form errors object
 * @property {array}    bindings.model    Text model reference
 * @property {string}   bindings.title    Input label and/or placeholder
 */
let cmsInputHtmlEditor = {
    bindings: {
        errors: '=',
        model: '=',
        label: '@',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: require('./html-editor.html'),
    controller: function () {

        this.contentLoaded = () => {
            return typeof this.model !== 'undefined';
        }

    }
};

/**
 * Html editor control. Includes editor implementation abstraction layer.
 * @namespace cms.input.htmlEditor
 */
export default angular.module('cms.input.htmlEditor', [textareaEditor]).component('cmsInputHtmlEditor', cmsInputHtmlEditor).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/HtmlEditorControl/CmsInputHtmlEditor.js